exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.gradient-border {\n  border: 2px solid transparent;\n  border-radius: 0.5rem;\n  background-origin: border-box;\n  background-clip: content-box, border-box;\n  background-image:\n    linear-gradient(var(--gl-background-color-overlap)),\n    linear-gradient(to bottom, #ff31e0, #c80043);\n}\n", ""]);

